import React from "react";
import moment from "moment";

const TablaPropuestas = ({ propuesta }) => {
  const { fecha, titulo, autor, estado, motivo } = propuesta
  const mFecha = moment(fecha);

  return (
    <table className="table table-borderless table-dark">
      <tbody>
        <tr>
          <th style={{ maxWidth: 50 }} scope="row">
            ARTÍCULO:
          </th>
          <td>{titulo || "Título Desconocido"}</td>
        </tr>
        <tr>
          <th style={{ maxWidth: 50 }} scope="row">
            POR:
          </th>
          <td>{autor?.displayName}</td>
        </tr>
        <tr>
          <th style={{ maxWidth: 50 }} scope="row">
            FECHA:
          </th>
          <td>
            {mFecha.format("LLL")} ({mFecha.fromNow()})
          </td>
        </tr>
        <tr>
          <th style={{ maxWidth: 50 }} scope="row">
            MOTIVO:
          </th>
          <td>
            {motivo || 'Sin Especificar'}
          </td>
        </tr>
        <tr>
          <th style={{ maxWidth: 50 }} scope="row">
            ESTADO:
          </th>
          <td>{estado || 'desconocido'}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default TablaPropuestas;
